import { combineReducers } from 'redux-immutablejs';

import caseReducer from './case';
import codefileReducer from './codefile';
import commentsReducer from './comments';
import configReducer from './config';
import dashboardReducer from './dashboard';
import firmReducer from './firm';
import discoveryReducer from './discovery';
import documentReducer from './document';
import evidenceReducer from './evidence';
import globalReducer from './global';
import messagesReduser from './messages';
import motionsReducer from './motions';
import offerReducer from './offer';
import partiesReducer from './parties';
import partiesSearchReducer from './partiesSearch';
import propertiesReducer from './properties';
import arbitrationPropertiesReducer from './arbitrationProperties';
import searchReducer from './search';
import settlementsReducer from './settlements';
import activityReducer from './activity';
import eventsReducer from './events';
import configurationReducer from './configuration';
import arbitratorReducer from './arbitrator';
import arbitrationReducer from './arbitration';
import arbitrationSearchReducer from './arbitrationSearch';
import litigationReducer from './litigation';
import arbitrationDocumentReducer from './arbitrationDocument';
import arbitrationEvidenceReducer from './arbitrationEvidence';

export default combineReducers({
  case: caseReducer,
  codefile: codefileReducer,
  comments: commentsReducer,
  config: configReducer,
  firm: firmReducer,
  discovery: discoveryReducer,
  document: documentReducer,
  evidence: evidenceReducer,
  global: globalReducer,
  messages: messagesReduser,
  motions: motionsReducer,
  offer: offerReducer,
  parties: partiesReducer,
  partiesSearch: partiesSearchReducer,
  properties: propertiesReducer,
  arbitrationProperties: arbitrationPropertiesReducer,
  search: searchReducer,
  settlements: settlementsReducer,
  activity: activityReducer,
  events: eventsReducer,
  configuration: configurationReducer,
  arbitrator: arbitratorReducer,
  arbitration: arbitrationReducer,
  arbitrationSearch: arbitrationSearchReducer,
  litigation: litigationReducer,
  arbitrationDocument: arbitrationDocumentReducer,
  arbitrationEvidence: arbitrationEvidenceReducer,
  dashboard: dashboardReducer,
});
